import LandingImg from '../../images/landing.png';
import react, { useState } from 'react'
import {
  LandingContainer,
  LandingBg,
  LandingGIF,
} from './LandingPageElements';

function LandingPage() {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };
  return (
    <LandingContainer>
      <LandingBg>
        <LandingGIF src={LandingImg} />
      </LandingBg>
    </LandingContainer>
  );
}

export default LandingPage;
